import config from '../config';
var CompanyService = /*@__PURE__*/ (function () {
    function CompanyService() {
    }
    CompanyService.get = function (rmsID) {
        return new Promise(function (resolve, reject) {
            jQuery.ajax({
                url: config.appointman.api.BASE_URI + "/company/" + rmsID,
                success: function (res) {
                    resolve(res);
                },
                error: function () {
                    reject();
                }
            });
        });
    };
    return CompanyService;
}());
export default CompanyService;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/service/Company.ts
// module id = null
// module chunks = 